export default "__VITE_ASSET__nyurQGwL__"